import React from 'react';
import { type PathTranslations } from 'service/localization/getPathTranslations';

export const GlobalContext = React.createContext<{
  themeName?: string;
  pathTranslations: PathTranslations;
  userToken: string;
}>({
  themeName: '',
  pathTranslations: {} as PathTranslations,
  userToken: '',
});

export const GlobalContextProvider = GlobalContext.Provider;
export const GlobalContextConsumer = GlobalContext.Consumer;
